module.exports = __webpack_public_path__ + "static/media/q1.5834a538.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/endtest/q2/q1.jpg
// module id = 249
// module chunks = 0